import { FC } from 'react'
import { useSelector } from 'react-redux'
import { userSelector } from 'ducks/user'
import MicrosoftSsoSection from 'views/screens/Companies/Company/MicrosoftSsoSection'
import IntegrationCredentialsSection from 'views/screens/Companies/Company/IntegrationCredentialsSection'
import { MainLayout } from 'views/layouts'

const PlatformConfiguration: FC = (): JSX.Element => {
  const { companyId } = useSelector(userSelector)

  return (
    <MainLayout>
      {companyId > 0 && (
        <>
          <MicrosoftSsoSection companyId={companyId} />
          <IntegrationCredentialsSection companyId={companyId} />
        </>
      )}
    </MainLayout>
  )
}

export default PlatformConfiguration
